import { render, staticRenderFns } from "./BlockUI.vue?vue&type=template&id=4dcf2b6d&"
import script from "./BlockUI.vue?vue&type=script&lang=js&"
export * from "./BlockUI.vue?vue&type=script&lang=js&"
import style0 from "./BlockUI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports